import { formatKrMoney } from '../../../../utils';
import { IgnorantCartItem } from '../../../payment/cart/IgnorantCartItem';
import { Subtitle } from '../../../../components/typography/Heading';
import styles from './DisplayCart.module.less';

export const DisplayCart = ({
    ignorantCartItems = [],
    totalSum,
    cartTitle = 'Fond i gave',
    cartSumSubText = 'inkl. mva og frakt',
}) => {
    return (
        <div className={styles.contentWrapper}>
            {cartTitle && <Subtitle>{cartTitle}</Subtitle>}
            <div className={styles.products}>
                {ignorantCartItems.map((item) => (
                    <IgnorantCartItem
                        key={item.title}
                        title={item.title}
                        price={item.price}
                        handleChange={item.handleChange}
                        handleDelete={item.handleDelete}
                    />
                ))}
            </div>
            <div className={styles.cartSum}>
                <div>
                    <p className={styles.cartSumItem}>Totalsum</p>
                    <span className={styles.cartSumMva}>{cartSumSubText}</span>
                </div>
                <span className={styles.cartSumItem}>{formatKrMoney(totalSum)}</span>
            </div>
        </div>
    );
};
